<template>
  <h1>
    <RouterLink to="/">
      <img :src="LogoImage" alt="logo" class="w-28 sm:w-32 md:w-36 xl:h-16 xl:w-48" />
    </RouterLink>
  </h1>
</template>

<script setup lang="ts">
import LogoImage from "@/assets/images/logo.svg";
</script>
